import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5075cf47&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5075cf47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5075cf47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5075cf47')) {
      api.createRecord('5075cf47', component.options)
    } else {
      api.reload('5075cf47', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5075cf47&scoped=true&", function () {
      api.rerender('5075cf47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/navSvg/index.vue"
export default component.exports